// newPage/DataPage.js
import React from 'react';
import SmartDataTable from '../../components/SmartDataTable';
import { tableConfig } from './tableConfig';

export default function DataPage() {
    return (
        <div className="content-scrollable">
            <div className="page-title">User List</div>
            <SmartDataTable config={tableConfig} />
        </div>
    );
}
